import axios from '@/utils/requset'
import { responseHandler } from '@/utils/http'

export function speakingTasksStart(parameter) {
  return axios({
    url: '/client/speakingTasks/speakingTasksStart',
    method: 'post',
    data: parameter
  })
}
export function getStartDate(parameter) {
  return axios({
    url: '/client/speakingTasks/getStartDate',
    method: 'post',
    data: parameter
  })
}

export function getSpeakingTasksPublishScriptsList(parameter) {
  return axios({
    url: '/client/speakingTasks/getSpeakingTasksPublishScriptsList',
    method: 'post',
    data: parameter
  })
}

export function getSpeakingTasksResult(parameter) {
  return axios({
    url: '/client/speakingTasks/getSpeakingTasksResult',
    method: 'get',
    params: parameter
  })
}

export function saveSpeakingTasksResult(parameter) {
  return axios({
    url: '/client/speakingTasks/saveSpeakingTasksResult',
    method: 'post',
    data: parameter,
  })
}





